import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mostrar)?_c(VAlert,{attrs:{"type":_vm.configuracion.tipo}},[_vm._v(" "+_vm._s(_vm.configuracion.mensaje)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }